import React, { useState } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import notiifcationicon from '../assets/images/navbar/notifcation.webp';
import dropdown from '../assets/images/navbar/dropdown.webp';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { apiUrl } from '../config/Config';
import userplaceholderimg from '../assets/images/userplaceholder.webp';

const Navbar = (props) => {
  const [shownavdropdown, setshownavdropdown] = useState(false);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userdata = useSelector((store) => store.userReducer.userdata);

  const handlelogout = async () => {
    try {
      const headers = {
        headers: {
          'Content-Type': 'application/json',
          // Authorization: "Bearer " + userdata?.token,
        }
      };

      const response = await axios.post(apiUrl + 'adminlogout', {}, headers);

      if (response.data.status === 'success') {
        dispatch({ type: "userdata", payload: {} });
        navigate('/');
      } else {
        if (response.data.message === 'invalid user') {
          dispatch({ type: "userdata", payload: {} });
          navigate('/');
        } else {
          alert(response.data.message);
        }
      }
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
      <div className="navbarmaindiv">
        <div className="navbarrow">
          <p className="nav-pagetitle">{props.title}</p>

          <div
            className="notificationbg"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
            }}
          >
            <img src={notiifcationicon} className="nav-notifyicon" alt="notification" />
          </div>

          <div
            className="nav-profilediv"
            onClick={() => {
              setshownavdropdown(!shownavdropdown);
            }}
          >
            <img src={userplaceholderimg} className="nav-userimg" alt="user" />

            <div className="nav-profilenamediv">
         
              <p className="nav-profilename">{userdata?.name || 'Admin'}</p>
              <p className="nav-profiledesig">{userdata?.type || 'superadmin'}</p>
            </div>

            <div className="nav-profiledowndiv">
              <img src={dropdown} className="nav-profiledownicon" alt="dropdown" />
            </div>

            {shownavdropdown && (
              <div className="dropdown-content" style={{ display: "block" }}>
                <div
                  onClick={handlelogout}
                  className={"sidebarnavrow navbardropdownicon atag"}
                >
                  <div className="navbarnavicon navbarnavicon1" />
                  <p className="shoppingtext">Sign Out</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
